import React, { useState } from "react";
import { Functions7FormulaModal } from "../modal";
import { SettingIcon, ReTryIcon, ChartIcon } from "../Icons";
import { MaterialMonitor } from "../../api";
import sleep from "./sleep";
import "./function.css";
import { message, Modal } from "antd";
import OilMonitorChart from "../chart/OilMonitorChart";
import { useGlobal } from "../../global/user";

export default function Function10({ machineID, data, status, machineInfo }) {
  const { user } = useGlobal();
  const [state, setState] = useState(data || {});
  const [onEdit, setOnEdit] = useState(false);
  const [onChart, setOnChart] = useState(false);
  const [bounds, setBounds] = useState({});
  const [makeUp, setMakeUp] = useState(0);
  const [A, setA] = useState([state.a, state.ra, state.sa, state.ta] || [1, 1, 1, 1]);
  const [B, setB] = useState([state.b, state.rb, state.sb, state.tb] || [0, 0, 0, 0]);
  const calculate = (type) => {
    switch (type) {
      case "total":
        return (parseFloat(A[0]) * parseFloat(state.voltage) + parseFloat(B[0])).toFixed(2);
      case "R":
        return (parseFloat(A[1]) * parseFloat(state.Rpressure) + parseFloat(B[1])).toFixed(2);
      case "S":
        return (parseFloat(A[2]) * parseFloat(state.Spressure) + parseFloat(B[2])).toFixed(2);
      case "T":
        return (parseFloat(A[3]) * parseFloat(state.Tpressure) + parseFloat(B[3])).toFixed(2);
      default:
        return "--";
    }
  };
  const ReloadData = async () => {
    const { IP, port, fake_update } = machineInfo;
    if (fake_update) {
      await sleep(3000);
      setState((data) => {
        const newData = { ...data };
        newData.Rpressure = Math.round((newData.Rpressure + (Math.random() * 4 - 2) / 100) * 100) / 100;
        newData.Spressure = Math.round((newData.Spressure + (Math.random() * 4 - 2) / 100) * 100) / 100;
        newData.Tpressure = Math.round((newData.Tpressure + (Math.random() * 4 - 2) / 100) * 100) / 100;
        newData.voltage = Math.round((newData.voltage + (Math.random() * 4 - 2) / 100) * 100) / 100;
        return newData;
      });
      return;
    }
    await MaterialMonitor.RestartServer(machineID);
    let response = await MaterialMonitor.Initialize(IP, port);
    if (response.code !== 200) {
      message.error(response.message);

      return;
    }
    for (let i = 0; i < 3; i++) {
      await sleep(3000);
      response = await MaterialMonitor.GetData(IP, port);
      if (response.code === 200) {
        break;
      }
    }
    if (response.code === 200)
      setState((data) => {
        const newData = { ...data };
        newData.Rpressure = response.data.Rpressure;
        newData.Spressure = response.data.Spressure;
        newData.Tpressure = response.data.Tpressure;
        newData.voltage = response.data.voltage;
        return newData;
      });
    else {
      response = await MaterialMonitor.RestartServer(machineID);
    }
    // else message.error("重載失敗");
  };
  const ReloadConfirm = () =>
    Modal.confirm({
      title: `確認刷新`,
      content: `確認刷新數位油壓 ${machineInfo.name} 數據`,
      onOk: ReloadData,
    });

  const openChart = async () => {
    const boundsRes = await MaterialMonitor.GetBounds(machineID);
    if (boundsRes.code === 200) {
      if (boundsRes.data.length > 0) {
        const bounds = boundsRes.data[0];
        setBounds({
          upperBound: bounds.upper_bound,
          lowerBound: bounds.lower_bound,
          tolerance: bounds.tolerance,
        });
      }
    } else alert("取得油壓上下限失敗");

    const makeUpRes = await MaterialMonitor.GetMakeUp(machineID);
    if (makeUpRes.code === 200) {
      const makeUp = makeUpRes.data;
      setMakeUp(makeUp);
    } else alert("取得補點開關失敗");

    setOnChart(true);
  };
  return (
    <React.Fragment>
      <td>
        <div className="d-flex justify-content-center py-2">
          <div style={{ width: "90%" }}>
            <div className="d-flex justify-content-between">
              {status !== "0" ? (
                <>
                  <div>
                    <span className="font-weight-bold mr-1">{`編號:`}</span>
                    <span className="mr-2 text-nowrap">{`${machineID}`}</span>
                  </div>
                  <div>
                    <span className="font-weight-bold mr-1">{`料位高(mm):`}</span>
                    <span className="mr-2 text-nowrap">{`${state.status ? calculate("total") : "--"}`}</span>
                  </div>
                  <div>
                    <span className="font-weight-bold mr-1">{`溫度(C):`}</span>
                    <span className="mr-2 text-nowrap">{`${state.status ? calculate("R") : "--"}`}</span>
                  </div>
                  <div>
                    <span className="font-weight-bold mr-1">{`濕度(%):`}</span>
                    <span className="mr-2 text-nowrap">{`${state.status ? calculate("S") : "--"}`}</span>
                  </div>
                  <div>
                    <span className="font-weight-bold mr-1">{`電壓(V):`}</span>
                    <span className="mr-2 text-nowrap">{`${state.status ? calculate("T") : "--"}`}</span>
                  </div>
                </>
              ) : (
                <div>--</div>
              )}
            </div>
            <div className="d-flex justify-content-center">
              {user.class >= process.env.REACT_APP_EDITOR_CALSS_LV && (
                <button className="control_setting" onClick={() => setOnEdit(true)}>
                  <SettingIcon className="button_svg control_svg" />
                </button>
              )}
              <button className="control_setting" onClick={ReloadConfirm}>
                <ReTryIcon className="button_svg control_svg" />
              </button>
              <button className="control_setting" onClick={openChart}>
                <ChartIcon className="button_svg control_svg" />
              </button>
            </div>
          </div>
        </div>
        <div>
          <Functions7FormulaModal open={onEdit} setA={setA} setB={setB} A={A} B={B} data={data} setVisible={setOnEdit} />
          <OilMonitorChart
            id={machineID}
            visible={onChart}
            setVisible={setOnChart}
            bounds={bounds}
            setBounds={setBounds}
            makeUp={makeUp}
            setMakeUp={setMakeUp}
            A={A}
            B={B}
          />
        </div>
      </td>
    </React.Fragment>
  );
}
